/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from '@/axios.js'
import navMenuItems from '../layouts/components/vertical-nav-menu/navMenuItems'
const actions = {

    // /////////////////////////////////////////////
    // COMPONENTS
    // /////////////////////////////////////////////

    // Vertical NavMenu
    updateVerticalNavMenuWidth({ commit }, width) {
      commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
    },

    // VxAutoSuggest
    updateStarredPage({ commit }, payload) {
      commit('UPDATE_STARRED_PAGE', payload)
    },

    // The Navbar
    arrangeStarredPagesLimited({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_LIMITED', list)
    },
    arrangeStarredPagesMore({ commit }, list) {
      commit('ARRANGE_STARRED_PAGES_MORE', list)
    },

    // /////////////////////////////////////////////
    // UI
    // /////////////////////////////////////////////

    toggleContentOverlay({ commit }) {
      commit('TOGGLE_CONTENT_OVERLAY')
    },
    updateTheme({ commit }, val) {
      commit('UPDATE_THEME', val)
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////

    updateUserInfo({ commit }, payload) {
      commit('UPDATE_USER_INFO', payload)
    },
    updateUserRole ({ dispatch }, payload) {
      // Change client side
      payload.aclChangeRole(payload.userRole.join(", "))
  
      // Make API call to server for changing role
  
      // Change userInfo in localStorage and store
      dispatch('updateUserInfo', {userRole: payload.userRole.join(", ")})
    },

    // /////////////////////////////////////////////
    // NOTIFICATIONS
    // /////////////////////////////////////////////
    addNotification({ commit }, item) {
      return new Promise((resolve, reject) => {
          axios.post('/api/notification', item)
            .then((response) => {
              commit('ADD_NOTIFICATION', response.data)//Object.assign(item, {employeeFiledLeaveId: response.data.data.employeeFiledLeaveId}))
              resolve(response)
            })
            .catch((error) => { reject(error) })
      })
    },
    getNotification({commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/notification')
            .then((response) => {
              // console.log('getNotification')
              // console.log(response)
              commit('GET_NOTIFICATIONS',  response.data)
              resolve(response)
            })
            .catch((error) => { reject(error) })
      })
    },
    markAsViewed({commit}, userNotifId) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/notification/markasviewed/${userNotifId}`)
            .then((response) => {
              commit('MARKASVIEWED',  userNotifId)
              resolve(response)
            })
            .catch((error) => { reject(error) })
      })
    },
    markAsHidden({commit}, userNotifId) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/notification/markashidden/${userNotifId}`)
            .then((response) => {
              commit('MARKASHIDDEN',  userNotifId)
              resolve(response)
            })
            .catch((error) => { reject(error) })
      })
    },

    getFile({commit}, fileId){
      return new Promise((resolve, reject) => {
        axios.get(`/api/file/${fileId}`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
     })
    },
    getPayslipList({commit}, userId){
      return new Promise((resolve, reject) => {
        axios.get('/api/reports/generatepaysliplist', { params: { userId : userId }})
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
     })
    },
    getViewPayslip({commit}, items){
      return new Promise((resolve, reject) => {
        axios.get('/api/reports/payslip', { params: { userId: items.userId, payOutDate: items.payOutDate }})
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
     })
    },
    uploadFile({commit}, formData) {
      var config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      };
        return new Promise((resolve, reject) => {
          axios.post('/api/file/upload', formData, config)
            
            .then((response) => {
              // console.log(response)
              commit('UPLOAD_FILE', response.data)
              resolve(response)
            })
            .catch((error) => { reject(error) })
      })
    },
    downloadFile({commit}, fileId) {
      return new Promise((resolve, reject) => {
         axios.get(`/api/file/download?fileId=${fileId}`, {
          reportProgress: true,
          responseType: 'blob',
          })
           .then((response) => {
             resolve(response)
           })
           .catch((error) => { reject(error) })
      })
    },
    deleteFile({commit}, fileId) {
      return new Promise((resolve, reject) => {
         axios.delete(`/api/file/${fileId}`)
           .then((response) => {
             resolve(response)
           })
           .catch((error) => { reject(error) })
      })
   },

    
}

export default actions
